import { PriceBreakdown } from './Order'
import { Proteins } from './Pet'

export const hasWeightLimit = (product: Product | ProductVariant) => product.needsMinimumWeightToPurchase

export enum ProductTypes {
  PATTIES = 'PATTIES',
  BONES = 'BONES',
  TREATS = 'TREATS',
  MEAL_PLANS = 'MEAL_PLANS',
  GIFT = 'GIFT',
  FREEZE_DRIED = 'FREEZE_DRIED'
}

export enum RawFeedingProductType {
  FROZEN = 'FROZEN',
  FREEZE_DRIED = 'FREEZE_DRIED',
}

export enum PouchSize {
  SIX_OUNCES = 6,
  SIXTEEN_OUNCES = 16,
  TWENTY_FIVE_OUNCES = 25,
}

export type TranslatedDescriptions = {
  enUS: string
  esES: string
}

export type Product = {
  productId: string
  name: string
  slug: string
  description: {
    enUS: string
    esES: string
  }
  needsMinimumWeightToPurchase: boolean
  unitWeight?: number
  price: PriceBreakdown
  proteins: Proteins[]
  weight: number
  type: ProductTypes
  image: string
  isHidden: boolean
  addOnExpiresAt?: string
  isAddOn?: boolean
  recurringPrice?: PriceBreakdown
}

export type ProductVariant = {
  productVariantId: string
  productId: string
  name: string
  slug: string
  description: {
    enUS: string
    esES: string
  }
  needsMinimumWeightToPurchase: boolean
  unitWeight?: number
  price: PriceBreakdown
  proteins: Proteins[]
  weight: number
  type: ProductTypes
  image: string
  isHidden: boolean
  addOnExpiresAt?: string
  isAddOn?: boolean
  recurringPrice?: PriceBreakdown
}

export type ProductSnapshot = {
  addOnExpiresAt: string
  isAddOn: boolean
  name: string
  price: number
  productId: string
  quantity: number
  weight: number
  slug: string
  type: ProductTypes
}

export type ProductVariantSnapshot = {
  productVariantId: string
  productId: string
  addOnExpiresAt: string
  isAddOn: boolean
  name: string
  price: number
  quantity: number
  weight: number
  slug: string
  type: ProductTypes
}

type AnalysisPercentages = {
  minRawProtein: number
  minRawFat: number
  maxRawFiber: number
  maxMoisture: number
}

export type ProductDetail = Product & {
  details: TranslatedDescriptions[]
  ingredients: { [k in Proteins]?: TranslatedDescriptions[] }
  analysisPercentages: { [k in Proteins]?: AnalysisPercentages }
  kilocaloriesPerOunces: { [k in Proteins]?: number }
  guidelines: TranslatedDescriptions[]
}

export type ProductVariantDetail = ProductVariant & {
  details: TranslatedDescriptions[]
  ingredients: { [k in Proteins]?: TranslatedDescriptions[] }
  analysisPercentages: { [k in Proteins]?: AnalysisPercentages }
  kilocaloriesPerOunces: { [k in Proteins]?: number }
  guidelines: TranslatedDescriptions[]
}

export type ShoppingCartItem = ProductVariant & {
  quantity: number
}

export type ShoppingCart = {
  clientId: string
  items: ShoppingCartItem[]
  priceBreakdown: PriceBreakdown
}
